"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSubscriptionPlacement = void 0;
var _analyticsData = require("@ori/analytics-data");
const parseSubscriptionPlacement = placement => {
  switch (placement) {
    case _analyticsData.Placement.MainProductDetail:
      return _analyticsData.Placement.ProductDetail;
    case _analyticsData.Placement.ProductListing:
      return _analyticsData.Placement.QuickbuyPLP;
    case _analyticsData.Placement.DigitalCatalogueECatalogue:
      return _analyticsData.Placement.QuickbuyECatalogue;
    case _analyticsData.Placement.TopNavigationSearchSuggestions:
      return _analyticsData.Placement.QuickbuySearch;
    default:
      return placement != null ? `${placement} - subscription` : undefined;
  }
};
exports.parseSubscriptionPlacement = parseSubscriptionPlacement;